<template>
  <div class="w-full screen-full">
    <!-- Background Image -->
    <img
      src="../assets/img/ab.png"
      alt="Background"
      class="absolute inset-0 object-cover w-full h-full z-0 brightness-75"
    />

    <!-- Left Content  -->
    <!-- <div class="absolute inset-0 sm:block hidden pgs-dnsc">
      <div
        class="w-[510px] h-[560px] rounded-b-[100px] xl:ml-[12%] lg:ml-[4%] ml-0 bg-[#147452] opacity-85 shadow pli-div1"
      >
        <div
          class="flex flex-col px-10 pt-5 text-white space-y-5 tracking-wide pli-div1-inner"
        >
          <div class="text-7xl font-extrabold space-y-1 mt-9 pli-title">
            <div class="pli-title-default">
              <h1>DAVAOs</h1>
              <h1>DELs</h1>
              <h1>NORTE</h1>
              <h1>STATE</h1>
              <h1>COLLEGE</h1>
            </div>
            <div class="hidden pli-title-hidden">
              <h1>DAVAO DEL NORTE STATE COLLEGE</h1>
            </div>
          </div>
          <div class="text-3xl font-semibold ml-1 pli-subtitle">
            <h2 class="italic">Information Systems Gateway</h2>
          </div>
        </div>
      </div>
    </div> -->

    <section class="absolute inset-0 font-inter">
      <div
        class="flex flex-col items-center justify-center min-h-screen px-6 py-8 md:h-screen lg:py-0"
      >
        <!-- Glass Container -->
        <div
          class="w-full max-w-4xl bg-white/10 backdrop-blur-md border border-white/30 rounded-2xl shadow-2xl flex flex-col md:flex-row items-stretch justify-between gap-10 p-5"
        >
          <!-- Left Section: Titles -->
          <div
            class="flex-1 flex flex-col justify-start items-start text-7xl font-extrabold pli-title text-white"
          >
            <div class="pli-title-default absolute bottom-20">
              <h1>DAVAO</h1>
              <h1>DEL</h1>
              <h1>NORTE</h1>
              <h1>STATE</h1>
              <h1>COLLEGE</h1>
            </div>
            <div class="hidden pli-title-hidden">
              <h1>DAVAO DEL NORTE STATE COLLEGE</h1>
            </div>

            <div class="text-3xl font-normal pli-subtitle bottom-6 absolute">
              <h2 class="">Information Systems Gateway</h2>
            </div>
          </div>

          <!-- Right Section: Login Form -->
          <div class="w-full max-w-sm bg-white rounded-xl shadow-lg p-6">
            <div class="space-y-4 md:space-y-6 font-poppins">
              <div class="flex items-center gap-2">
                <img src="../assets/img/dnsc_logo.png" alt="" class="h-6" />
                <h1
                  class="text-xl font-semibold tracking-wide md:text-1xl text-gray-900"
                >
                  Sign in to your account.
                </h1>
              </div>

              <!-- Notification -->
              <div
                v-if="message"
                :class="
                  isSuccess
                    ? 'text-green-600'
                    : 'text-white w-full py-3 bg-[#F40009] rounded-md'
                "
                class="text-sm font-medium text-center"
              >
                {{ message }}
              </div>

              <!-- Login Form -->
              <form @submit.prevent="login" class="space-y-4 md:space-y-3">
                <div>
                  <label
                    class="block mb-2 text-sm font-medium text-gray-900 tracking-wide"
                  >
                    Email Address
                  </label>
                  <input
                    type="text"
                    v-model="email"
                    class="bg-gray-50 text-sm border border-gray-300 text-gray-900 rounded-lg w-full p-2.5"
                    placeholder="Enter email address ..."
                    required
                  />
                </div>
                <div class="relative">
                  <label
                    class="block mb-2 text-sm font-medium text-gray-900 tracking-wide mt-3"
                  >
                    Password
                  </label>
                  <input
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    class="bg-gray-50 text-sm border border-gray-300 text-gray-900 rounded-lg w-full p-2.5"
                    placeholder="Enter password ..."
                  />
                  <span
                    @click="togglePasswordVisibility"
                    class="absolute right-3 top-10 cursor-pointer"
                  >
                    <icon :name="showPassword ? 'eye-close' : 'eye-open'" />
                  </span>
                </div>

                <div>
                  <input
                    type="submit"
                    value="Login"
                    class="bg-green1 mt-5 border border-gray-300 text-white rounded-lg w-full p-2.5 cursor-pointer hover:bg-green2 transition ease-in duration-150"
                  />
                </div>
              </form>

              <!-- Logos (Justify Between) -->
              <div class="flex justify-center gap-4">
                <img
                  src="../assets/img/bagongpilipinas.png"
                  alt="Bagong Pilipinas"
                  class="w-[55px] h-auto"
                />
                <img
                  src="../assets/img/dnsc_logo.png"
                  alt="DNSC Logo"
                  class="w-[51px] h-auto"
                />

                <img
                  src="../assets/img/corseal.png"
                  alt="DNSC ISO"
                  class="w-8 h-[51px] z-20 cursor-pointer"
                  @click="showRegistration = true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- Home Button (Fixed Bottom Right) -->
  <div class="flex justify-between">
    <router-link
      to="/"
      class="fixed bottom-8 right-8 z-50 cursor-pointer group"
    >
      <div
        class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 hover:text-white transition-all duration-300 relative"
      >
        <!-- House Icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-7 w-7 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 9.75L12 3l9 6.75V21a1 1 0 01-1 1h-5v-6h-6v6H4a1 1 0 01-1-1V9.75z"
          />
        </svg>
        <!-- Hover Text -->
        <span
          class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        >
          Home
        </span>
      </div>
    </router-link>
  </div>

  <!-- ✅ MODAL OUTSIDE -->
  <div
    v-if="showRegistration"
    class="fixed inset-0 z-[9999] flex items-center justify-center px-4"
  >
    <!-- BACKDROP -->
    <div
      class="absolute inset-0 bg-black/50 backdrop-blur-sm"
      @click="showRegistration = false"
    ></div>

    <!-- MODAL -->
    <div
      class="relative z-10 w-full max-w-5xl max-h-[90vh] overflow-y-auto p-4 sm:p-6 rounded-2xl bg-white/20 backdrop-blur-xl border border-white/30 shadow-2xl"
    >
      <!-- HEADER -->
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-white text-lg sm:text-xl md:text-2xl font-semibold">
          Certificate of Registration 2026
        </h2>

        <button
          @click="showRegistration = false"
          class="text-white text-lg p-2 hover:bg-white/20 rounded-full"
        >
          <icon name="close" />
        </button>
      </div>

      <!-- CONTENT -->
      <div class="flex flex-col lg:flex-row gap-6 items-center justify-center">
        <!-- CERTIFICATE -->
        <div class="w-full flex justify-center">
          <img
            src="../assets/img/registration.jpg"
            class="w-full max-w-[500px] md:max-w-[600px] lg:max-w-[730px] object-contain rounded-lg"
          />
        </div>

        <!-- CORSEAL -->
        <div class="flex justify-center">
          <img
            src="../assets/img/corseal.png"
            class="w-[230px] sm:w-[230px] md:w-[230px] lg:w-[300px] object-contain"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "./icon.vue";

export default {
  name: "LoginPage",
  components: {
    icon,
  },
  data() {
    return {
      email: "",
      password: "",
      message: "",
      isSuccess: false,
      showPassword: false,
      showRegistration: false,
    };
  },
  mounted() {
    if (this.$store.state.user) {
      if (!this.$store.state.user.id) {
        localStorage.removeItem("token");
        setTimeout(function () {
          location.reload();
        }, 3000);
      } else {
        this.$router.push("/user/system-pages");
      }
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    async login() {
      this.message = ""; // clear previous message
      this.isSuccess = false;

      try {
        let data = {
          email: this.email,
          password: this.password,
        };
        this.axiosCall("/auth/login", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.isSuccess = true;
            this.message = "Login successful!";
            localStorage.setItem("token", res.data.token);
            this.$store.dispatch("setUser", res.data.user);
            this.$router.push("/user/system-pages");
          } else {
            this.isSuccess = false;
            this.message = res.data.message;
          }
        });
      } catch (error) {
        this.$store.dispatch("setUser", null);
        this.isSuccess = false;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.message = error.response.data.message;
        } else {
          this.message = "Wrong Email or Password";
        }
        console.error(error);
      }
    },
  },
};
</script>
<style scoped></style>
